var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenMuseaLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      isolation: "isolate"
    },
    viewBox: "-3299.74 3983.792 1328.705 1326.683",
    width: "1328.705pt",
    height: "1326.683pt",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: " M -2469.83 4003.77 Q -2299.983 4047.997 -2168.528 4174.845 L -2404.717 4395.677 Q -2458.158 4344.077 -2538.628 4320.121 L -2469.83 4003.77 Z ",
    fill: "rgb(149,223,99)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M -2159.007 4184.366 Q -2042.295 4306.914 -1996.839 4462.018 L -2307.354 4544.945 Q -2328.24 4476.761 -2392.738 4406.119 L -2159.007 4184.366 Z ",
    fill: "rgb(115,209,62)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M -1992.038 4806.085 Q -1948.759 4668.38 -1994.661 4476.249 L -2302.202 4559.199 Q -2279.907 4648.38 -2296.956 4724.445 L -2296.956 4725.757 L -1992.038 4806.085 Z ",
    fill: "rgb(81,196,26)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M -2300.891 4741.167 L -1995.317 4822.478 Q -2035.972 4977.888 -2151.382 5101.822 L -2384.497 4891.658 Q -2327.448 4837.56 -2300.891 4741.167 Z ",
    fill: "rgb(57,157,15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M -2530.029 4985.313 Q -2462.691 4965.019 -2392.586 4903.216 L -2163.822 5113.531 Q -2292.963 5240.828 -2453.467 5284.182 L -2530.029 4985.313 Z ",
    fill: "rgb(36,120,5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M -2717.885 4991.229 Q -2638.34 5013.796 -2542.755 4989.52 L -2468.411 5291.449 Q -2654.271 5331.655 -2807.511 5286.897 L -2717.885 4991.229 Z ",
    fill: "rgb(17,82,0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M -3282.349 4497.259 L -2976.568 4577.487 Q -2995.948 4650.853 -2977.471 4728.228 L -3277.73 4810.221 Q -3319.304 4667.021 -3282.349 4497.259 Z ",
    fill: "rgb(81,196,26)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M -3119.803 4191.911 L -2881.44 4406.401 Q -2945.824 4465.72 -2974.76 4562.657 L -3278.591 4482.359 Q -3246.761 4334.422 -3119.803 4191.911 Z ",
    fill: "rgb(115,209,62)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M -3107.143 4180.698 Q -2997.909 4067.123 -2833.695 4012.867 L -2733.865 4318.869 Q -2806.206 4338.401 -2871.674 4394.465 L -3107.143 4180.698 Z ",
    fill: "rgb(149,223,99)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M -2871.712 4911.86 Q -2813.649 4963.544 -2730.98 4989.132 L -2823.328 5285.22 Q -3004.572 5220.884 -3098.067 5121.485 L -2871.712 4911.86 Z ",
    fill: "rgb(36,120,5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M -3274.61 4825.258 L -2974.233 4744.387 Q -2954.015 4830.313 -2883.253 4901.797 L -3109.48 5111.154 Q -3222.403 4998.443 -3274.61 4825.258 Z ",
    fill: "rgb(57,157,15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: " M -2819.989 4009.955 Q -2661.067 3962.386 -2482.685 4001.306 L -2554.038 4316.988 Q -2615.661 4294.285 -2720.528 4314.826 L -2819.989 4009.955 Z ",
    fill: "rgb(183,235,143)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenMuseaLogo);
export default __webpack_public_path__ + "static/media/Green_Musea_Logo.3ce6fc03a040f17eac8528ab43b9cfef.svg";
export { ForwardRef as ReactComponent };